import React from "react";

interface Props {}

export const DrawRectangleIcon = (props: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <path stroke="#616161" strokeWidth="1.5" d="M4.75 4.75H19.25V19.25H4.75z"></path>
      </g>
    </svg>
  );
};
